module.exports = __webpack_public_path__ + "media/images/glanz-act-6374d2ba50f49c1c45da5f2b9cc2f69b.png";